import { render, staticRenderFns } from "./SignedInfoDialog.vue?vue&type=template&id=0facfce6"
import script from "./SignedInfoDialog.vue?vue&type=script&lang=js"
export * from "./SignedInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports